export const clickImpression = {
    chat:"chat",
    phone:"phone",
    website:"website",
    facility:"facility"

}